import { GraphQLClient } from 'graphql-request'

import Queries from './graphql/queries'

class API {
	constructor() {}

	request(...args) {
		return new GraphQLClient(process.env.VUE_APP_DATO_CMS_ENDPOINT, {
			headers: { Authorization: `Bearer ${process.env.VUE_APP_DATO_CMS_TOKEN}` },
		}).request(...args)
	}

	getPage(slug) {
		if (!slug) slug = 'hjem'
		return this.request(Queries.Page, {
			filter: {
				slug: { eq: slug },
			},
		}).then(data => {
			return data
		})
	}
}

export default new API()
